export default "/_next/static/chunks/fonts/Outfit Black-5027173f4209fc26184c5d54af46c81c.ttf";